import { toJS } from 'mobx';
import { observer } from 'mobx-react';
import React from 'react';

import DeiveryZoneMapArea from '../../components/DeiveryZoneMapArea/DeiveryZoneMapArea';
import deliveryZonesStore from '../../stores/deliveryZonesStore';

const DeliveryZonesMapAreas = observer(() => {
  return (
    <>
      {toJS(deliveryZonesStore.pagination.data)
        .filter((zone) => zone.id !== deliveryZonesStore.draft?.id)
        .reverse()
        .map((zone, index) => (
          <DeiveryZoneMapArea index={index} key={zone.id} zone={zone} />
        ))}
    </>
  );
});

export default DeliveryZonesMapAreas;
